import * as React from 'react';
import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';

export default function ImageCardMajoitus({ para }) {
    return (
        <Box
            
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    maxWidth: {
                        xs: '80vw',
                        sm: '80vw',
                        md: '90vw',
                        lg: '90vw',
                    },
                }}
            >


                <Card
                    sx={{
                        display: 'flex',
                        //minWidth: '75vw',
                        flexDirection:
                        {
                            xs: 'column',
                            sm: 'column',
                            md: 'row-reverse',
                            lg: 'row-reverse'
                        },
                        width: {
                            xs: '85%',
                            sm: '85%',
                            md: '75%',
                            lg: '75%',
                        },
                        height: '100%',
                    }}
                >

                    <CardMedia
                        sx={{
                            width: { xs: '99%', sm: '99%', md: '50%', lg: '50%' },
                            minHeight: '99%',
                            margin: '0.5%',
                            borderRadius: '3px',
                            
                        }}
                        component="img"
                        image={para.pic}
                        
                    />
                    <CardContent
                        sx={{
                            
                            display: 'flex',
                            flexDirection: 'column',
                            width: { xs: '100%', sm: '100%', md: '50%', lg: '50%' },
                            //height: { xs: '100%', sm: '100%', md: '100%', lg: '100%' },
                            
                            /*
                            old 
                            width: { xs: '100%', sm: '100%', md: '50%', lg: '50%' },
                            height: { xs: '50%', sm: '50%', md: '100%', lg: '100%' },
                            */
                            padding: 0,
                            margin: 0,
                            p: 0,
                            '&:last-child': { pb: 0 },
                        }}
                    >
                        <Typography
                            gutterBottom variant="h5"
                            component="h2"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                paddingTop: 2,
                                fontSize:
                                {
                                    xs: '6.8vw',
                                    sm: '4.5vw',
                                    md: "2.8vw",
                                    lg: "2.95vw"
                                },
                            }}
                        >
                            {para.hea}
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                margin: 0,
                                marginBottom: '0.75rem',
                                fontSize:
                                {
                                    xs: '5.0vw',
                                    sm: '2.8vw',
                                    md: "1.8vw",
                                    lg: "1.95vw"
                                },

                            }}
                        >
                            Majoittua Hyvinkäällä voi <a href="https://g.page/hotelsveitsi?share" 
                            target="_blank" rel="noopener noreferrer">Hotel Sveitsissä </a>
                            tai <a href="https://goo.gl/maps/WDiZEd2usrRdRMmMA" target="_blank" 
                            rel="noopener noreferrer">Scandicissa</a>.
                            Scandic sijaitsee Hyvinkään keskustassa. Sveitsi sijaitsee hieman sivummalla,
                            mutta on hotellina viihtyisämpi <i>(ainakin allekirjoittaneiden mielestä)</i>.
                        </Typography>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            component="p"
                            sx={{
                                paddingLeft: 2,
                                paddingRight: 2,
                                margin: 0,
                                marginBottom: '0.75rem',
                                fontSize:
                                {
                                    xs: '5.0vw',
                                    sm: '2.8vw',
                                    md: "1.8vw",
                                    lg: "1.95vw"
                                },

                            }}
                        >
                            Olemme neuvotelleet 10 % alennuksen majoituksen hinnasta Hotel Sveitsiin koodilla W14.
                        </Typography>
                        
                    </CardContent>
                </Card>
            </Box>

        </Box>





    );
}
